"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ethereum = void 0;
var React = __importStar(require("react"));
var Ethereum = function () {
    return (React.createElement("svg", { width: 36, height: 27, viewBox: "0 0 36 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d_277_4817)" },
            React.createElement("g", { filter: "url(#filter1_d_277_4817)" },
                React.createElement("rect", { x: 1, y: 1, width: 34, height: 24, rx: 4, fill: "#6481E7" })),
            React.createElement("ellipse", { cx: 17.935, cy: 12.935, rx: 7.935, ry: 7.93499, fill: "#6481E7" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.468 13.258l3.56 2.104v-8.01l-3.56 5.906z", fill: "#fff" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.028 7.352v8.01l3.56-2.104-3.56-5.906z", fill: "#C1CCF5" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.028 11.64l-3.56 1.618 3.56 2.104 3.56-2.104-3.56-1.618z", fill: "#8299EC" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.028 11.64l-3.56 1.618 3.56 2.104V11.64z", fill: "#C1CCF5" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.468 13.933l3.56 5.016v-2.913l-3.56-2.103z", fill: "#fff" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.028 16.036v2.913l3.562-5.016-3.562 2.103z", fill: "#C1CCF5" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_277_4817", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4817" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4817", result: "shape" })),
            React.createElement("filter", { id: "filter1_d_277_4817", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4817" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4817", result: "shape" })))));
};
exports.Ethereum = Ethereum;
